module.exports = __webpack_public_path__ + "static/media/comment-icon.cfdc9851.svg";